module.exports = {
	"header": "Nouvelles & Presse",
	"contact": "Contact Presse",
	"logosAndGuidelines": "Logos et Lignes directrices",
	"releases": "Communiqués de Presse",
	"publicRelations": "Presse et Relations publiques"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/press.json5
// module id = 2006
// module chunks = 6